import React from "react";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import VideoPromo from "@/components/VideoPromo";
import Categories from "@/components/Categories";
import SportsSection from "@/components/SportsSection";
import MoviesSection from "@/components/MoviesSection";
import SeriesSection from "@/components/SeriesSection";
import FeaturedContent from "@/components/FeaturedContent";
import Benefits from "@/components/Benefits";
import Testimonials from "@/components/Testimonials";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App bg-black min-h-screen">
      <Header />
      <Hero />
      <VideoPromo />
      <Categories />
      <SportsSection />
      <MoviesSection />
      <SeriesSection />
      <FeaturedContent />
      <Benefits />
      <Testimonials />
      <Footer />
    </div>
  );
}

export default App;
